var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1707481916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 33699",
    d: "M2.5 6.82866C2.5 6.01388 3.08979 5.32726 3.90095 5.25052C5.12796 5.13443 7.16098 5.00012 10 5C12.8392 4.99988 14.8723 5.13425 16.0993 5.25041C16.9104 5.32719 17.5 6.01375 17.5 6.82843V6.88789C17.5 7.88124 16.6363 8.65841 15.6461 8.57936C14.2046 8.46428 12.1023 8.33333 10 8.33333C7.89772 8.33333 5.79544 8.46428 4.35387 8.57936C3.36367 8.65841 2.5 7.88124 2.5 6.88789V6.82866Z",
    stroke: "#111111",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 33700",
    d: "M3.33341 8.74999C3.33341 8.74999 6.25008 8.33333 10.0001 8.33333C13.7501 8.33333 16.6667 8.74999 16.6667 8.74999C16.6667 8.74999 17.0834 9.99999 17.0834 12.9167C17.0834 14.5267 16.8295 15.7558 16.602 16.534C16.4248 17.1399 15.8513 17.5 15.22 17.5H4.78014C4.14885 17.5 3.57534 17.1399 3.39818 16.534C3.17067 15.7558 2.91675 14.5267 2.91675 12.9167C2.91675 9.99999 3.33341 8.74999 3.33341 8.74999Z",
    stroke: "#111111",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 768",
    d: "M10 5V17.5",
    stroke: "#111111",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33374 1.66658C6.95303 1.66658 5.83374 2.78587 5.83374 4.16658C5.83374 4.45878 5.88387 4.73926 5.97599 4.99991H8.33374H10.6915C10.7836 4.73926 10.8337 4.45878 10.8337 4.16658C10.8337 2.78587 9.71445 1.66658 8.33374 1.66658ZM8.33374 4.99991C8.79398 4.99991 9.16707 4.62682 9.16707 4.16658C9.16707 3.70634 8.79398 3.33325 8.33374 3.33325C7.8735 3.33325 7.50041 3.70634 7.50041 4.16658C7.50041 4.62682 7.8735 4.99991 8.33374 4.99991Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6663 1.66658C10.2855 1.66658 9.16626 2.78587 9.16626 4.16658C9.16626 4.45878 9.21639 4.73926 9.30851 4.99991H11.6663H14.024C14.1161 4.73926 14.1663 4.45878 14.1663 4.16658C14.1663 2.78587 13.047 1.66658 11.6663 1.66658ZM11.6663 4.99991C12.1265 4.99991 12.4996 4.62682 12.4996 4.16658C12.4996 3.70634 12.1265 3.33325 11.6663 3.33325C11.206 3.33325 10.8329 3.70634 10.8329 4.16658C10.8329 4.62682 11.206 4.99991 11.6663 4.99991Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/Gift.7c33d17a4242c3eb4cdeba87de6f33b8.svg";
export { ForwardRef as ReactComponent };